import styled from "styled-components"
import { Button } from "@netdata/netdata-ui"

const ExpandButton = styled(Button)`
&& {
  > .button-icon {
    width: 6px;
    height: 9px;
  }
`
export default ExpandButton
